// extracted by mini-css-extract-plugin
export default {"profileQrcode":"ProfileQrCode_profileQrcode__wbPUC","qrcodeContainer":"ProfileQrCode_qrcodeContainer__CgGUC","secondaryBtn":"ProfileQrCode_secondaryBtn__KyyJy"};